export const phone = '(415) 869-0411'
export const calendlyUrl = 'https://calendly.com/dpnelson/session'

export const nav = {
  links: [
    {
      label: 'About',
      href: '#about',
      children: ['About Douglas', 'Client Journey', 'Coaching vs. Therapy', 'What is IFS?', 'Models & Frameworks'],
    },
    { label: 'Services', href: '#services' },
    { label: 'Explore', href: '#blog' },
    { label: 'Contact Me', href: '#contact' },
  ],
  cta: 'Book Your Free Consultation',
}

export const footer = {
  heading: "Let's Connect.",
  subheading: 'All you need is a real conversation to start!',
  cta: 'Book Your Session Today',
  phone: '(415) 869-0411',
  copyright: '©2026 DP Nelson – All Rights Reserved',
}
